/**
 * Client-side de-duplication for error reports, matching Sentry's
 * `dedupeIntegration` semantics: an event is dropped when it is identical to
 * the immediately-previous captured event (same type, value, and stack
 * frames — encoded in the dedupe key), with no time window. Only the single
 * previous event is remembered, so alternating errors are all reported while
 * a crash loop repeating the same error reports once.
 *
 * Pure and dependency-free; covered by __tests__/dedup.test.ts.
 */

export class ErrorDeduper {
    private previousKey: string | undefined;

    /**
     * Returns true if this key should be reported now, false if it is
     * identical to the previous event's key.
     */
    shouldReport(key: string): boolean {
        if (this.previousKey !== undefined && key === this.previousKey) {
            return false;
        }
        this.previousKey = key;
        return true;
    }
}
